module.exports = __webpack_public_path__ + "21ed399c8d312bc6de6409f135b070b8.png";